require('./rangeslider.css');
module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "c267");
/******/ })
/************************************************************************/
/******/ ({

/***/ "17ed":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "517d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5e69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"43d6cb30-vue-loader-template"}!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib??vue-loader-options!./src/components/RangeSlider.vue?vue&type=template&id=80d0d914&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",style:({width: _vm.width, height: _vm.height})},[_c('div',{staticClass:"range-slider"},[_c('bar',{ref:"bar",staticClass:"range-slider__bar",attrs:{"barOptions":_vm.barOptions,"max":_vm.max,"sliceNum":_vm.sliceNum}}),_c('handle',{ref:"handleMin",staticClass:"range-slider__handle--min",attrs:{"handleOptions":_vm.handleOptions,"tooltipOptions":_vm.tooltipOptions,"value":this.minValue,"type":"min"}}),_c('handle',{ref:"handleMax",staticClass:"range-slider__handle--max",attrs:{"handleOptions":_vm.handleOptions,"tooltipOptions":_vm.tooltipOptions,"value":this.maxValue,"type":"max"}})],1),_c('range',{attrs:{"min":_vm.min,"max":_vm.max,"sliceNum":_vm.sliceNum,"rangeOptions":_vm.rangeOptions}})],1)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/RangeSlider.vue?vue&type=template&id=80d0d914&

// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"43d6cb30-vue-loader-template"}!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib??vue-loader-options!./src/components/Bar.vue?vue&type=template&id=09b26b2e&scoped=true&
var Barvue_type_template_id_09b26b2e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.barStyles)},[_c('div',{class:_vm.barOptions.sliceType === 'dot' ? 'range-slider__slice--dot' : 'range-slider__slice',style:({backgroundColor: ("" + (_vm.barOptions.sliceColor)), left: '0%'})}),_vm._l((_vm.sliceNum),function(index){return _c('div',{key:index,class:_vm.barOptions.sliceType === 'dot' ? 'range-slider__slice--dot' : 'range-slider__slice',style:({left: ((_vm.slicePercent * index) + "%"), backgroundColor: ("" + (_vm.barOptions.sliceColor))})})}),_c('div',{class:_vm.barOptions.sliceType === 'dot' ? 'range-slider__slice--dot' : 'range-slider__slice',style:({backgroundColor: ("" + (_vm.barOptions.sliceColor)), left: '100%'})})],2)}
var Barvue_type_template_id_09b26b2e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Bar.vue?vue&type=template&id=09b26b2e&scoped=true&

// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib??vue-loader-options!./src/components/Bar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Barvue_type_script_lang_js_ = ({
  name: 'Bar',
  props: ['barOptions', 'max', 'sliceNum'],
  data() {
    return {
      slicePercent: {
        type: Number,
      },
    };
  },
  beforeMount() {
    this.slicePercent = 100 / (this.sliceNum + 1);
  },
  computed: {
    barStyles() {
      return {
        width: this.barOptions.width,
        height: this.barOptions.height,
        backgroundColor: this.barOptions.color,
      };
    },
  },
});

// CONCATENATED MODULE: ./src/components/Bar.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Barvue_type_script_lang_js_ = (Barvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/Bar.vue?vue&type=style&index=0&id=09b26b2e&scoped=true&lang=css&
var Barvue_type_style_index_0_id_09b26b2e_scoped_true_lang_css_ = __webpack_require__("73fd");

// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/Bar.vue






/* normalize component */

var component = normalizeComponent(
  components_Barvue_type_script_lang_js_,
  Barvue_type_template_id_09b26b2e_scoped_true_render,
  Barvue_type_template_id_09b26b2e_scoped_true_staticRenderFns,
  false,
  null,
  "09b26b2e",
  null
  
)

/* harmony default export */ var Bar = (component.exports);
// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"43d6cb30-vue-loader-template"}!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib??vue-loader-options!./src/components/Handle.vue?vue&type=template&id=4ffd7cdd&scoped=true&
var Handlevue_type_template_id_4ffd7cdd_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"handle",style:(_vm.handleStyles),on:{"mouseenter":_vm.handleHover,"mouseleave":_vm.handleLeave}},[_c('div',{ref:"handle_hover",staticClass:"range-slider__handle",style:(_vm.handleStyles)}),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.visibility),expression:"this.visibility"}],staticClass:"range-slider__tooltip",style:(_vm.tooltipStyles)},[_vm._v(" "+_vm._s(this.value)+" ")])])],1)}
var Handlevue_type_template_id_4ffd7cdd_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Handle.vue?vue&type=template&id=4ffd7cdd&scoped=true&

// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib??vue-loader-options!./src/components/Handle.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Handlevue_type_script_lang_js_ = ({
  name: 'Handle',
  props: ['handleOptions', 'tooltipOptions', 'value'],
  data() {
    return {
      currentX: 0,
      xOffset: 0,
      initialX: 0,
      currentVal: 0,
      defaultHandleValue: {

      },
      defaultTooltipValue: {

      },
      visibility: true,
      clicked: false,
    };
  },
  beforeMount() {
    if (!this.tooltipOptions.visibility) this.visibility = false;
  },
  computed: {
    handleStyles() {
      return {
        cursor: 'pointer',
        width: this.handleOptions.width,
        height: this.handleOptions.height,
        backgroundColor: this.handleOptions.color,
        border: this.handleOptions.border,
        borderRadius: this.handleOptions.borderRadius,
      };
    },
    tooltipStyles() {
      return {
        backgroundColor: this.tooltipOptions.color,
        top: this.tooltipOptions.top ? this.tooltipOptions.top : this.tooltipOptions.height,
        width: this.tooltipOptions.width,
        height: this.tooltipOptions.height,
        lineHeight: this.tooltipOptions.height,
        border: this.tooltipOptions.border,
        borderRadius: this.tooltipOptions.borderRadius,
        color: this.tooltipOptions.textColor,
      };
    },

  },
  methods: {
    handleHover() {
      if (!this.tooltipOptions.visibility) this.visibility = true;
      this.$refs.handle_hover.classList.add('range-slider__handle--hover');
    },
    handleLeave() {
      if (this.clicked) return;
      if (!this.tooltipOptions.visibility) this.visibility = false;
      this.$refs.handle_hover.classList.remove('range-slider__handle--hover');
    },
  },
});

// CONCATENATED MODULE: ./src/components/Handle.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Handlevue_type_script_lang_js_ = (Handlevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/Handle.vue?vue&type=style&index=0&id=4ffd7cdd&scoped=true&lang=css&
var Handlevue_type_style_index_0_id_4ffd7cdd_scoped_true_lang_css_ = __webpack_require__("a3d3");

// CONCATENATED MODULE: ./src/components/Handle.vue






/* normalize component */

var Handle_component = normalizeComponent(
  components_Handlevue_type_script_lang_js_,
  Handlevue_type_template_id_4ffd7cdd_scoped_true_render,
  Handlevue_type_template_id_4ffd7cdd_scoped_true_staticRenderFns,
  false,
  null,
  "4ffd7cdd",
  null
  
)

/* harmony default export */ var Handle = (Handle_component.exports);
// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"43d6cb30-vue-loader-template"}!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!/Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib??vue-loader-options!./src/components/Range.vue?vue&type=template&id=5a85b04e&scoped=true&
var Rangevue_type_template_id_5a85b04e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"range-slider__range"},[_c('div',{staticClass:"range-slider__range-label",staticStyle:{"left":"0%"}},[_vm._v(_vm._s(_vm.min))]),_vm._l((_vm.sliceNum),function(index){return _c('div',{key:index,staticClass:"range-slider__range-label",style:([{left: ((_vm.slicePercent * index) + "%")}, _vm.rangeStyles])},[_vm._v(" "+_vm._s(_vm.min + Math.round((_vm.max - _vm.min) / (_vm.sliceNum + 1) * index))+" ")])}),_c('div',{staticClass:"range-slider__range-label",staticStyle:{"left":"100%"}},[_vm._v(_vm._s(_vm.max))])],2)}
var Rangevue_type_template_id_5a85b04e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/Range.vue?vue&type=template&id=5a85b04e&scoped=true&

// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib??vue-loader-options!./src/components/Range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var Rangevue_type_script_lang_js_ = ({
  props: ['min', 'max', 'sliceNum', 'rangeOptions'],
  data() {
    return {
      slicePercent: {
        type: Number,
      },
    };
  },
  computed: {
    rangeStyles() {
      return {
        color: this.rangeOptions.textColor,
      };
    },
  },
  beforeMount() {
    this.slicePercent = 100 / (this.sliceNum + 1);
  },
});

// CONCATENATED MODULE: ./src/components/Range.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Rangevue_type_script_lang_js_ = (Rangevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/Range.vue?vue&type=style&index=0&id=5a85b04e&scoped=true&lang=css&
var Rangevue_type_style_index_0_id_5a85b04e_scoped_true_lang_css_ = __webpack_require__("98d1");

// CONCATENATED MODULE: ./src/components/Range.vue






/* normalize component */

var Range_component = normalizeComponent(
  components_Rangevue_type_script_lang_js_,
  Rangevue_type_template_id_5a85b04e_scoped_true_render,
  Rangevue_type_template_id_5a85b04e_scoped_true_staticRenderFns,
  false,
  null,
  "5a85b04e",
  null
  
)

/* harmony default export */ var Range = (Range_component.exports);
// CONCATENATED MODULE: ./src/utils/keyBoardEventHandler.js
const TOOLTIP_DURATION = 300;

function move(direction) {
  if (!this.clickedHandle) return;

  if (this.clickedHandle === this.$refs.handleMin) {
    this.calculateMinHandlePosition(direction);
    if(this.checkFlowed('keyboard', this.minPosition)) return this.toggleTooltip(TOOLTIP_DURATION);
    this.moveMinHandle();
  }

  if (this.clickedHandle === this.$refs.handleMax) {
    this.calculateMaxHandlePosition(direction);
    if(this.checkFlowed('keyboard', this.maxPosition)) return this.toggleTooltip(TOOLTIP_DURATION);
    this.moveMaxHandle();
  }

  this.toggleTooltip(TOOLTIP_DURATION);
  this.returnHandleValues();
}

function moveToNextHandle() {
  
  if (!this.clickedHandle) {
    this.clickedHandle = this.$refs.handleMin;
    return this.clickedHandle.$el.classList.add('focused');
  } 

  if (this.clickedHandle === this.$refs.handleMin) {
    this.clickedHandle = this.$refs.handleMax;
    this.$refs.handleMin.$el.classList.remove('focused');
    return this.clickedHandle.$el.classList.add('focused');
  }

  if (this.clickedHandle === this.$refs.handleMax) {
    this.clickedHandle.$el.classList.remove('focused');
    this.clickedHandle = null;
  }
}

function moveToPrevHandle() {
  if(!this.clickedHandle) return;

  if (this.clickedHandle === this.$refs.handleMin) {
    this.clickedHandle.$el.classList.remove('focused');
    this.clickedHandle = null;
  }

  if (this.clickedHandle === this.$refs.handleMax) {
    this.clickedHandle = this.$refs.handleMin;
    this.clickedHandle.$el.classList.add('focused');
    this.$refs.handleMax.$el.classList.remove('focused');
  }
}



// CONCATENATED MODULE: ./src/utils/keyCodes.js

const keyCodes = {
  keyMap: {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ENTER: 13,
    BACK: 8,
  },

  getKeyByValue: function (keyCode) {
    return Object.keys(this.keyMap).find(key => this.keyMap[key] === keyCode);
  }
}



// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/cache-loader/dist/cjs.js??ref--0-0!/Users/shbae/.config/yarn/global/node_modules/vue-loader/lib??vue-loader-options!./src/components/RangeSlider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var RangeSlidervue_type_script_lang_js_ = ({
  name: 'RangeSlider',
  components: {
    bar: Bar,
    handle: Handle,
    range: Range,
  },
  mixins: [],
  data() {
    return {
      barOptions: {
        width: '100%',
        height: '10px',
        color: 'black',
        sliceColor: '#049DBF',
      },
      handleOptions: {
        width: '12px',
        height: '12px',
        color: '#D93D4A',
        borderRadius: '50%',
      },
      tooltipOptions: {
        width: '20px',
        height: '20px',
        color: '#F2C84B',
        visibility: false,
        borderRadius: '30%',
        textColor: 'white',
      },
      barWidth: {
        type: Number,
      },
      rangeOptions: {
        textColor: 'black',
      },
      clickedHandle: null,
      minPosition: 0,
      maxPosition: 0,
      minValue: 0,
      maxValue: 0,
    };
  },
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    bar: {
      type: Object,
    },
    handle: {
      type: Object,
    },
    tooltip: {
      type: Object,
    },
    range: {
      type: Object,
    },
    sliceNum: {
      type: Number,
      default: 3,
    },
    width: {
      type: String,
      default: '50%',
    },
    height: {
      type: String,
      default: '',
    },
    defaultMin: {
      type: Number,
      default: 50,
    },
    defaultMax: {
      type: Number,
      default: 70,
    },
    keyboardMove: {
      type: Boolean,
      default: false,
    },
    gap: {
      type: Number,
      default: 5,
    }
  },
  beforeMount() {
    this.setOptions();
  },
  mounted() {
    this.setInitialHandleValue();
    this.addEventListeners();
  },
  methods: {
    move: move,
    moveToNextHandle: moveToNextHandle,
    moveToPrevHandle: moveToPrevHandle,
    addEventListeners() {
      document.addEventListener('mousedown', this.whichHandleClicked);
      window.addEventListener('resize', this.setInitialHandleValue);
      if(this.keyboardMove) window.addEventListener('keydown', this.handleKeyboardEvent);
    },
    setInitialHandleValue() {
      this.barWidth = this.$refs.bar.$el.getBoundingClientRect().width;

      this.minValue = this.defaultMin;
      this.maxValue = this.defaultMax;

      this.minPosition =
        Math.abs(this.min - this.minValue) / (this.max - this.min);
      this.maxPosition =
        Math.abs(this.min - this.maxValue) / (this.max - this.min);

      const minPercentage = this.minPosition * 100;
      const maxPercentage = this.maxPosition * 100;

      this.$refs.handleMin.$el.style.left = `${minPercentage}%`;
      this.$refs.handleMax.$el.style.left = `${maxPercentage}%`;
    },
    setOptions() {
      Object.assign(this.barOptions, this.bar);
      Object.assign(this.handleOptions, this.handle);
      Object.assign(this.tooltipOptions, this.tooltip);
      Object.assign(this.rangeOptions, this.range);
    },
    whichHandleClicked(e) {
      e.preventDefault();
      if (e.target === this.$refs.handleMin.$el) {
        this.clickedHandle = this.$refs.handleMin;
      } else if (e.target === this.$refs.handleMax.$el) {
        this.clickedHandle = this.$refs.handleMax;
      } else return;

      this.handleClicked();
    },
    showTooltip() {
      this.clickedHandle.handleHover();
      this.clickedHandle.clicked = true;
      this.clickedHandle.visibility = true;
    },
    hideTooltip() {
      this.clickedHandle.clicked = false;
      this.clickedHandle.handleLeave();
    },
    toggleTooltip(time) {
      this.showTooltip();
      setTimeout(() => this.hideTooltip(), time);
    },
    handleClicked() {
      if (!this.clickedHandle) return;

      this.showTooltip();
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.onDragEnd);
    },
    checkFlowed(type, val) {
      if (val <= 0) {
        this.clickedHandle.$el.style.left = '0';
        this.updateFlowedValue('under');
        return true;
      }

      if (val >= this.barWidth || (type === 'keyboard' && val >= 1)) {
        this.clickedHandle.$el.style.left = 'initial';
        this.clickedHandle.$el.style.right = '0';
        this.updateFlowedValue('over');
        return true;
      }
      return false;
    },
    updateFlowedValue(flowed) {
      if(flowed === 'under') {
        if(this.clickedHandle === this.$refs.handleMin) {
          this.minValue = 0;
          this.minPosition = 0;
        } else {
          this.maxValue = 0;
          this.maxPosition = 0;
        }
      } else {
        if(this.clickedHandle === this.$refs.handleMin) {
          this.minValue = this.max;
          this.minPosition = 1;
        } else {
          this.maxValue = this.max;
          this.maxPosition = 1;
        }
      }
      this.returnHandleValues();
    },
    moveMinHandle() {
      const minPercentage = this.minPosition * 100;
      this.minValue = Math.round(this.minPosition * (this.max - this.min)) + this.min;
      this.clickedHandle.$el.style.left = `${minPercentage}%`;
    },
    moveMaxHandle() {
      const maxPercentage = this.maxPosition * 100;
      this.maxValue = Math.round(this.maxPosition * (this.max - this.min)) + this.min;
      this.clickedHandle.$el.style.left = `${maxPercentage}%`;
    },
    onDrag(e) {
      e.preventDefault();

      if (this.checkFlowed('mouse', e.clientX)) return;

      if (this.clickedHandle === this.$refs.handleMin) {
        this.minPosition = e.clientX / this.barWidth;
        this.moveMinHandle();
      }

      if (this.clickedHandle === this.$refs.handleMax) {
        this.maxPosition = e.clientX / this.barWidth;
        this.moveMaxHandle();
      }
      
      this.returnHandleValues();
    },
    returnHandleValues() {
      this.$emit('getMinValue', this.getMinValue());
      this.$emit('getMaxValue', this.getMaxValue());
    },
    getMinValue() {
      return this.minValue;
    },
    getMaxValue() {
      return this.maxValue;
    },
    onDragEnd(e) {
      e.preventDefault();

      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.onDragEnd);

      this.hideTooltip();
      this.returnHandleValues();
    },
    handleKeyboardEvent(e) {
      e.preventDefault();

      const keyCode = keyCodes.getKeyByValue(e.keyCode);
      if (keyCode === 'LEFT') return this.move(keyCode);
      if (keyCode === 'RIGHT') return this.move(keyCode);
      if (keyCode === 'ENTER' || keyCode === 'DOWN') return this.moveToNextHandle();
      if (keyCode === 'BACK' || keyCode === 'UP') return this.moveToPrevHandle();
    },
    calculateMinHandlePosition(direction) {
      if(direction === 'LEFT') this.minPosition = this.minPosition - (this.gap / this.max);
      if(direction === 'RIGHT') this.minPosition = this.minPosition + (this.gap / this.max);
    },
    calculateMaxHandlePosition(direction) {
      if(direction === 'LEFT') this.maxPosition = this.maxPosition - (this.gap / this.max);
      if(direction === 'RIGHT') this.maxPosition = this.maxPosition + (this.gap / this.max);
    },
  },
});

// CONCATENATED MODULE: ./src/components/RangeSlider.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_RangeSlidervue_type_script_lang_js_ = (RangeSlidervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/RangeSlider.vue?vue&type=style&index=0&lang=css&
var RangeSlidervue_type_style_index_0_lang_css_ = __webpack_require__("da36");

// CONCATENATED MODULE: ./src/components/RangeSlider.vue






/* normalize component */

var RangeSlider_component = normalizeComponent(
  components_RangeSlidervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var RangeSlider = __webpack_exports__["a"] = (RangeSlider_component.exports);

/***/ }),

/***/ "73e6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "73fd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Bar_vue_vue_type_style_index_0_id_09b26b2e_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c047");
/* harmony import */ var _config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Bar_vue_vue_type_style_index_0_id_09b26b2e_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Bar_vue_vue_type_style_index_0_id_09b26b2e_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Bar_vue_vue_type_style_index_0_id_09b26b2e_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "98d1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Range_vue_vue_type_style_index_0_id_5a85b04e_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("17ed");
/* harmony import */ var _config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Range_vue_vue_type_style_index_0_id_5a85b04e_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Range_vue_vue_type_style_index_0_id_5a85b04e_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Range_vue_vue_type_style_index_0_id_5a85b04e_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a3d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Handle_vue_vue_type_style_index_0_id_4ffd7cdd_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("73e6");
/* harmony import */ var _config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Handle_vue_vue_type_style_index_0_id_4ffd7cdd_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Handle_vue_vue_type_style_index_0_id_4ffd7cdd_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_Handle_vue_vue_type_style_index_0_id_4ffd7cdd_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a8ab":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "ad89":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "b635":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return install; });
/* harmony import */ var _components_RangeSlider_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5e69");
/* harmony import */ var _assets_range_slider_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("517d");
/* harmony import */ var _assets_range_slider_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_assets_range_slider_css__WEBPACK_IMPORTED_MODULE_1__);
// import Vue from 'vue';



// Declare install function executed by Vue.use()
function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component("RangeSlider", _components_RangeSlider_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
}

// Create module definition for Vue.use()
const plugin = {
  install
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

// To allow use as module (npm/webpack/etc.) export component
/* harmony default export */ __webpack_exports__["a"] = (_components_RangeSlider_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("ad89")))

/***/ }),

/***/ "c047":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c267":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "install", function() { return /* reexport */ src_0["b" /* install */]; });

// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("a8ab")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/index.js
var src_0 = __webpack_require__("b635");

// CONCATENATED MODULE: /Users/shbae/.config/yarn/global/node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0["a" /* default */]);



/***/ }),

/***/ "da36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_RangeSlider_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f4c3");
/* harmony import */ var _config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_RangeSlider_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_RangeSlider_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_config_yarn_global_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_config_yarn_global_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_config_yarn_global_node_modules_vue_loader_lib_loaders_stylePostLoader_js_config_yarn_global_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_config_yarn_global_node_modules_cache_loader_dist_cjs_js_ref_0_0_config_yarn_global_node_modules_vue_loader_lib_index_js_vue_loader_options_RangeSlider_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f4c3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ });
//# sourceMappingURL=rangeslider.common.js.map